import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import './app.css';
import './utils/i18n';
import CDNContainer from './container/CDNContainer';
import NPMContainer from './container/NPMContainer';
import FeaturesContainer from './container/FeaturesContainer';
import PageCompatiblityContainer from './container/PageCompatiblityContainer';
import FeaturesDetailContainer from './container/FeaturesDetailContainer';
import ExceptionContainers from './container/ExceptionsContainer';
import ProfileCreationContainer from './container/ProfileCreationContainer';
import IncidentLevelContainer from './container/IncidentLevelContainer';
import CorderApiDocumentationContainer from './container/CorderApiDocumentationContainer';

const AppShell = () => (
	<div className='app-container'>
		<Routes>
			<Route path="/" element={<CDNContainer />} />
			<Route path="/npm" element={<NPMContainer />} />
			<Route path="/ai" element={<Navigate to="/features/ai" replace />} />
			<Route path="/features" element={<FeaturesContainer />} />
			<Route path="/features/:id" element={<FeaturesDetailContainer />} />
			<Route path="/documentation/:id" element={<ExceptionContainers />} />
			<Route path="/compatibility/:id" element={<PageCompatiblityContainer />} />
			<Route path="/profile" element={<ProfileCreationContainer />} />
			<Route path="/incident-level" element={<IncidentLevelContainer />} />
		</Routes>
	</div>
);

const App = () => {
	return (
		<Routes>
			<Route
				path="/documentation/corder-api"
				element={<CorderApiDocumentationContainer />}
			/>
			<Route path="*" element={<AppShell />} />
		</Routes>
	);
};

export default App;
